import './App.css';
import 'ag-grid-community/styles/ag-grid.css'; // Mandatory CSS required by the grid
import 'ag-grid-community/styles/ag-theme-quartz.css'; // Optional Theme applied to the grid
import AppRoutes from './Routes';
import {
  useKeycloak,
  useDayjs,
  UserRole,
  currentUserState,
  useStartup,
} from '@laborability/commons';
import { KeycloakContext, LBTLabel } from '@laborability/components';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { Box } from '@mui/material';

function App() {
  useDayjs();
  const { keycloak, init } = useKeycloak();
  const { onStartup, isCompletedStartup } = useStartup();
  const currentUser = useRecoilValue(currentUserState);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (keycloak?.tokenParsed) onStartup();
  }, [keycloak?.tokenParsed]);

  if (
    isCompletedStartup &&
    currentUser.role !== UserRole.ADMIN &&
    currentUser.role !== UserRole.COMPANY
  ) {
    keycloak?.logout();
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('idToken');
    localStorage.removeItem('login');
    keycloak?.login();
  }

  return (
    <KeycloakContext.Provider value={{ keycloak }}>
      {isCompletedStartup ? (
        <AppRoutes />
      ) : (
        <Box
          width="100vw"
          height="100vh"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <LBTLabel variant="spGroteskTitle">CARICAMENTO...</LBTLabel>
        </Box>
      )}
    </KeycloakContext.Provider>
  );
}

export default App;
